export default __webpack_public_path__ + "static/media/dollar-sign.8d9a6f93.svg";